export type { Language, Translations } from './types';
export { ko } from './ko';
export { en } from './en';

import type { Language, Translations } from './types';
import { ko } from './ko';
import { en } from './en';

export const translations: Record<Language, Translations> = {
  ko,
  en,
};

